export const AttachWalletGetChallengeMutation = `
mutation AttachWalletGetChallenge($walletAddress: String!, $walletType: String!) {
  attachWalletGetChallenge(walletAddress: $walletAddress, walletType: $walletType) {
    challenge
  }
}
`;
